import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space } = theme

export const Hero = styled.section`
  width: 100%;
  background-image: linear-gradient(60deg, #01284b, transparent), url('${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/security-fraud/ciberSeguranca.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: ${space['spacing-xl']} 0;

  span {
    display: block;
  }

  @media (${media.tablet}) {
    h1 {
      padding-bottom: ${space['spacing-sm']};
    }

    p {
      font-size: 1.25rem;
    }
  }

  @media (${media.desktop}) {
    padding: ${space['spacing-giga']} 0;

    span {
      display: inline;
    }
  }
`
